import Swiper, { Autoplay } from 'swiper';
Swiper.use([ Autoplay ]);

export default () => {
    let container = document.querySelector('.about-brands__slider');
    if (container) {
        let brandsSlider = slider(container);
    }
}

let slider = (container) => {
    let swiper = new Swiper(container, {
        slidesPerView: 2,
        spaceBetween: 50,
        observer: true,
        observeParents: true,
        loop: true,
        centeredSlides: false,
        autoplay: {
            delay: 2500,
            disableOnInteraction: true,
        },
        breakpoints: {
            576: {
                slidesPerView: 3,
                centeredSlides: true,
                spaceBetween: 50,
            },
            768: {
                slidesPerView: 4,
                centeredSlides: false,
                spaceBetween: 70,
            },
            1200: {
                slidesPerView: 5,
                centeredSlides: true,
                spaceBetween: 100,
            },
            1440: {
                slidesPerView: 7,
                centeredSlides: true,
                spaceBetween: 100,
            }
        }
    });

    return swiper;
}
